import React from 'react';

interface Step2A_ShareGoalProps {
  selectedGoal: 'keep' | 'sell' | null;
  onSelect: (goal: 'keep' | 'sell') => void;
}

const Step2A_ShareGoal: React.FC<Step2A_ShareGoalProps> = ({ selectedGoal, onSelect }) => {
  return (
    <div className="wizard-step">
      <div className="wizard-step-content">
        <h2 className="wizard-question">
          What's your goal with these shares?
        </h2>

        <div className="wizard-options-container">
          <button
            className={`wizard-pill-button ${selectedGoal === 'keep' ? 'selected' : ''}`}
            onClick={() => onSelect('keep')}
            aria-pressed={selectedGoal === 'keep'}
          >
            <div className="pill-button-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
            </div>
            <div className="pill-button-content">
              <div className="pill-button-title">Keep my shares</div>
              <div className="pill-button-subtitle">
                Lower income, higher chance to keep shares
              </div>
              <div className="pill-button-details">
                30-45 day contracts • Delta 0.05-0.15 • More conservative
              </div>
            </div>
          </button>

          <button
            className={`wizard-pill-button ${selectedGoal === 'sell' ? 'selected' : ''}`}
            onClick={() => onSelect('sell')}
            aria-pressed={selectedGoal === 'sell'}
          >
            <div className="pill-button-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="12" y1="1" x2="12" y2="23" />
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
              </svg>
            </div>
            <div className="pill-button-content">
              <div className="pill-button-title">Okay to sell for profit</div>
              <div className="pill-button-subtitle">
                Higher income, might be sold at strike price
              </div>
              <div className="pill-button-details">
                7-21 day contracts • Delta 0.25-0.40 • More aggressive
              </div>
            </div>
          </button>
        </div>

        <p className="wizard-helper-text">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{display: 'inline', marginRight: '6px', verticalAlign: 'text-bottom'}}>
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4" />
            <path d="M12 8h.01" />
          </svg>
          This determines which options contracts we'll show you for each stock.
        </p>
      </div>
    </div>
  );
};

export default Step2A_ShareGoal;
